// @docs https://[domain]/api/v1/docs
export default {
  List: "/master-data/timezones",
  ListShort: "/master-data/timezones/short",
};
